module.exports = __webpack_public_path__ + "js/stellarium-web-engine.4b426088.wasm";